<template>
  <div class="con">
    <div
      class="item"
      v-for="(item, index) in fourdata"
      :key="index"
      @click="showMore"
    >
      <img class="pic" :src="item.src" />
      <div class="r">
        <div class="tit">{{ item.tit }}</div>
        <div class="num">
          {{ item.num }}<span>{{ item.unit }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import pollingFunction from "@/utils/tools";
export default {
  computed: {
    ...mapState(["componentCallsData"]),
  },
  data() {
    return {
      fourdata: [
        {
          src: require("../assets/svgIcon/cw.svg"),
          tit: "床位数",
          num: "182",
          unit: "张",
        },
        {
          src: require("../assets/svgIcon/rzlr.svg"),
          tit: "入住老人",
          num: "182",
          unit: "人",
        },
        {
          src: require("../assets/svgIcon/rzl.svg"),
          tit: "入住率",
          num: "18",
          unit: "%",
        },
        {
          src: require("../assets/svgIcon/dy.svg"),
          tit: "组件调用",
          num: "38123",
          unit: "次",
        },
      ],
      pollingST: null,
    };
  },
  async mounted() {
    if (!this.pollingST) {
      setTimeout(() => {
        this.pollingST = pollingFunction(this.getData, 3000);
      }, 3000);
    }
    await this.getData();
  },
  methods: {
    ...mapActions(["getComponentCallsData"]),
    async getData() {
      let json = {
        rows: 6,
        branchId: 6627,
      };
      await this.getComponentCallsData(json);
      if (this.componentCallsData) {
        this.$set(
          this.fourdata[0],
          "num",
          this.componentCallsData.data.data.beds
        );
        this.$set(
          this.fourdata[1],
          "num",
          this.componentCallsData.data.data.elders
        );
        this.$set(
          this.fourdata[2],
          "num",
          this.componentCallsData.data.data.intoRatio
        );
        this.$set(
          this.fourdata[3],
          "num",
          this.componentCallsData.data.data.moduleUseCount
        );
      }
    },

    showMore() {
      this.$store.commit("setServiceDrawer", true);
      this.$store.commit("setCurrentMenu", "headthrough");
    },
  },
  destroyed() {
    clearTimeout(this.pollingST);
  },
};
</script>

<style lang="scss" scoped>
.con {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  // background: url('../../assets/svgIcon/fwtj.svg');
  // mask: url("../../assets/index/fwtj.svg") no-repeat 50% 50%;
  .item {
    display: flex;
    align-items: center;
    .pic {
      width: 44px;
      height: 44px;
    }
    .r {
      min-width: 80px;
      height: 44px;
      margin-left: 8px;
      .tit {
        font-size: 14px;
        color: #79daff;
      }
      .num {
        color: #fff;
        font-size: 25px;
        span {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
